/* ============================================================
   VS PREMIUM CART
   Reliable Shopify AJAX cart controls
   ============================================================ */
(function () {
  'use strict';

  const ROOT_SELECTOR = '[data-vs-premium-cart]';

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function url(path) {
    return rootUrl() + String(path).replace(/^\/+/, '');
  }

  async function request(path, options) {
    const response = await fetch(url(path), Object.assign({
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    }, options || {}));

    let data = null;
    try { data = await response.json(); } catch (e) {}

    if (!response.ok) {
      throw new Error(
        (data && (data.description || data.message || data.status)) ||
        'Unable to update cart.'
      );
    }

    return data;
  }

  async function getCart() {
    return request('cart.js', { method: 'GET' });
  }

  function dispatchCart(cart) {
    document.dispatchEvent(new CustomEvent('vs:cart:updated', {
      bubbles: true,
      detail: { cart: cart }
    }));
    document.dispatchEvent(new CustomEvent('cart:updated', {
      bubbles: true,
      detail: { cart: cart }
    }));
    document.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: { cart: cart }
    }));
  }

  function updateCounters(cart) {
    if (!cart) return;

    const count = Number(cart.item_count || 0);
    document.querySelectorAll([
      '[data-vs-cart-count]',
      '[data-cart-count]',
      '[data-cart-item-count]',
      '.cart-count',
      '.header__cart-count',
      '.cart-count-bubble span'
    ].join(',')).forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-vs-cart-count-value', String(count));
    });

    document.querySelectorAll('[data-vs-cart-heading-count]').forEach(function (el) {
      el.textContent = '(' + count + ')';
    });
  }

  function getRootElement() {
    return document.querySelector(ROOT_SELECTOR);
  }

  function getItemFromControl(control) {
    return control && control.closest('[data-vs-cart-item]');
  }

  function getLineKey(item) {
    if (!item) return null;

    return item.dataset.lineKey ||
      item.dataset.cartLineKey ||
      item.dataset.itemKey ||
      (item.querySelector('[data-line-item-key]') || {}).dataset?.lineItemKey ||
      null;
  }

  function getQuantity(item) {
    const input = item && item.querySelector('[data-vs-quantity]');
    const value = input ? parseInt(input.value, 10) : 1;
    return Number.isFinite(value) ? Math.max(0, value) : 1;
  }

  function setBusy(item, busy) {
    if (!item) return;
    item.classList.toggle('vs-cart-is-loading', busy);
    item.querySelectorAll('button, input').forEach(function (el) {
      el.disabled = busy;
    });
  }

  function setPageBusy(busy) {
    const root = getRootElement();
    if (!root) return;
    const form = root.querySelector('.vs-pc__form');
    if (form) form.classList.toggle('vs-is-busy', busy);
  }

  function showError(message) {
    let box = document.querySelector('[data-vs-cart-error]');
    if (!box) {
      box = document.createElement('div');
      box.setAttribute('data-vs-cart-error', '');
      Object.assign(box.style, {
        position:'fixed',
        left:'50%',
        bottom:'24px',
        transform:'translateX(-50%)',
        zIndex:'99999',
        maxWidth:'calc(100vw - 30px)',
        padding:'13px 18px',
        borderRadius:'10px',
        background:'#111',
        color:'#fff',
        fontSize:'13px',
        fontWeight:'700',
        boxShadow:'0 12px 35px rgba(0,0,0,.2)'
      });
      document.body.appendChild(box);
    }
    box.textContent = message || 'Something went wrong.';
    box.hidden = false;
    clearTimeout(box._vsTimer);
    box._vsTimer = setTimeout(function () {
      box.hidden = true;
    }, 3500);
  }

  function selectedItems(root) {
    return Array.from(root.querySelectorAll('[data-vs-item-select]:checked'))
      .map(function (input) { return input.closest('[data-vs-cart-item]'); })
      .filter(Boolean);
  }

  function syncSelection(root) {
    const boxes = Array.from(root.querySelectorAll('[data-vs-item-select]'));
    const checked = boxes.filter(function (box) { return box.checked; });
    const selectAll = root.querySelector('[data-vs-select-all]');
    const count = root.querySelector('[data-vs-selected-count]');
    const removeSelected = root.querySelector('[data-vs-remove-selected]');

    if (selectAll) {
      selectAll.checked = boxes.length > 0 && checked.length === boxes.length;
      selectAll.indeterminate = checked.length > 0 && checked.length < boxes.length;
    }

    if (count) count.textContent = checked.length + ' selected';
    if (removeSelected) removeSelected.disabled = checked.length === 0;
  }

  async function changeLine(item, quantity, trigger) {
    const line = getLineKey(item);
    if (!line) {
      showError('Cart line could not be found. Please refresh the page.');
      return;
    }

    setBusy(item, true);

    try {
      const cart = await request('cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: line,
          quantity: Math.max(0, Number(quantity))
        })
      });

      dispatchCart(cart);
      updateCounters(cart);
      window.location.reload();
    } catch (error) {
      setBusy(item, false);
      showError(error.message);
    }
  }

  async function clearCart() {
    if (!window.confirm('Remove all products from your cart?')) return;

    setPageBusy(true);

    try {
      const cart = await request('cart/clear.js', {
        method: 'POST',
        headers: { Accept: 'application/json' }
      });

      dispatchCart(cart);
      updateCounters(cart);
      window.location.reload();
    } catch (error) {
      setPageBusy(false);
      showError(error.message);
    }
  }

  async function removeSelected(root) {
    const items = selectedItems(root);
    if (!items.length) return;

    if (!window.confirm('Remove the selected products from your cart?')) return;

    setPageBusy(true);

    try {
      const updates = {};
      items.forEach(function (item) {
        const line = getLineKey(item);
        if (line) updates[line] = 0;
      });

      if (!Object.keys(updates).length) {
        throw new Error('Selected cart lines could not be found.');
      }

      const cart = await request('cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ updates: updates })
      });

      dispatchCart(cart);
      updateCounters(cart);
      window.location.reload();
    } catch (error) {
      setPageBusy(false);
      showError(error.message);
    }
  }

  function handleQuantityButton(button) {
    const item = getItemFromControl(button);
    if (!item || item.classList.contains('vs-cart-is-loading')) return;

    const input = item.querySelector('[data-vs-quantity]');
    if (!input) return;

    const current = parseInt(input.value, 10) || 1;

    if (button.matches('[data-vs-qty-minus]')) {
      changeLine(item, Math.max(0, current - 1), button);
      return;
    }

    if (button.matches('[data-vs-qty-plus]')) {
      const max = input.max ? Number(input.max) : Infinity;
      changeLine(item, Math.min(max, current + 1), button);
    }
  }

  function bind(root) {
    if (!root || root.dataset.vsCartBound === 'true') return;
    root.dataset.vsCartBound = 'true';

    root.addEventListener('click', function (event) {
      const button = event.target.closest('button');
      if (!button || !root.contains(button)) return;

      if (button.matches('[data-vs-clear-cart]')) {
        event.preventDefault();
        clearCart();
        return;
      }

      if (button.matches('[data-vs-remove-selected]')) {
        event.preventDefault();
        removeSelected(root);
        return;
      }

      if (button.matches('[data-vs-remove]')) {
        event.preventDefault();
        const item = getItemFromControl(button);
        if (item) changeLine(item, 0, button);
        return;
      }

      if (button.matches('[data-vs-qty-minus], [data-vs-qty-plus]')) {
        event.preventDefault();
        handleQuantityButton(button);
        return;
      }
    });

    root.addEventListener('change', function (event) {
      const input = event.target;

      if (input.matches('[data-vs-select-all]')) {
        root.querySelectorAll('[data-vs-item-select]').forEach(function (box) {
          box.checked = input.checked;
        });
        syncSelection(root);
        return;
      }

      if (input.matches('[data-vs-item-select]')) {
        syncSelection(root);
        return;
      }

      if (input.matches('[data-vs-quantity]')) {
        const item = getItemFromControl(input);
        if (item) {
          const value = Math.max(0, parseInt(input.value, 10) || 0);
          input.value = value;
          changeLine(item, value, input);
        }
      }
    });

    root.addEventListener('input', function (event) {
      const input = event.target;
      if (!input.matches('[data-vs-quantity]')) return;

      let value = parseInt(input.value, 10);
      if (!Number.isFinite(value) || value < 0) value = 0;
      input.value = value;
    });

    const couponInput = root.querySelector('[data-vs-coupon]');
    const couponButton = root.querySelector('[data-vs-apply-coupon]');

    function applyCoupon() {
      if (!couponInput) return;
      const code = couponInput.value.trim();
      const message = root.querySelector('[data-vs-coupon-message]');

      if (!code) {
        if (message) {
          message.textContent = 'Enter a coupon code.';
          message.dataset.state = 'error';
          message.hidden = false;
        }
        return;
      }

      if (message) {
        message.textContent = 'Applying coupon…';
        message.dataset.state = '';
        message.hidden = false;
      }

      const config = document.querySelector('[data-vs-cart-config]');
      let discountUrl = rootUrl() + 'discount/';
      if (config) {
        try {
          const parsed = JSON.parse(config.textContent || '{}');
          if (parsed.discountUrl) discountUrl = parsed.discountUrl;
        } catch (e) {}
      }

      window.location.href = discountUrl + encodeURIComponent(code) + '?redirect=/cart';
    }

    if (couponButton) couponButton.addEventListener('click', applyCoupon);
    if (couponInput) {
      couponInput.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          applyCoupon();
        }
      });
    }

    syncSelection(root);
  }

  async function refreshHeaderCart() {
    try {
      const cart = await getCart();
      updateCounters(cart);
    } catch (error) {}
  }

  function init() {
    const root = getRootElement();
    if (root) bind(root);
    refreshHeaderCart();
  }

  document.addEventListener('shopify:section:load', init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();